module.exports = __webpack_public_path__ + "media/images/loading/coolsis-be7d9a1dbc458adb1656ffb51e260470.png";